<template>
  <article id="work" class="layout-section">
    <div class="layout-section__hgroup -center">
      <h2 v-scroll:reveal class="layout-section__title">{{ content.title }}</h2>
    </div>

    <div class="layout-grid">
      <WorkItem
        v-for="(item, i) in workItems"
        :key="item.title"
        v-scroll:reveal="{ delay: i * 75 + 100 }"
        :item="item"
      />
    </div>

    <div class="layout-section__cta -center">
      <a
        v-scroll:reveal="{delay:225}"
        :href="content.link || 'https://mariedooley.com/collections/artwork'" 
        target="_blank"
        class="button layout-section__cta"
      >
        {{ content.label }}
      </a>
    </div>
  </article>
</template>

<script>
import WorkItem from '@/components/work-item/WorkItem.vue'

export default {
  name: 'HomeContentImage',
  components: { WorkItem },

  computed: {
    workItems() {
      return this.$i18n.t('projects')
    },
    content() {
      return this.$i18n.t('cta')
    }
  }
}
</script>
